import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

export function ChevronButton({
  onClick,
  children,
  disabled,
  className,
  dataTutorial,
}: {
  onClick: () => void;
  children: React.ReactNode;
  disabled: boolean;
  className?: string;
  dataTutorial?: string;
}) {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "flex w-full max-w-xs items-center justify-between truncate rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:leading-6",
        className
      )}
      disabled={disabled}
      data-tutorial={dataTutorial}
    >
      <span className="truncate">{children}</span>
      <ChevronRightIcon className="h-4" />
    </button>
  );
}
